/**
 * MainSalesCommon.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * (분양페이지용 MainCommon)
 * 서버 API로부터 기본 데이터를 전달받도록 제어하는 기본 로직이 정의.
 * 여기서 제어하는 기본 데이터는 '분양페이지 기본 데이터' 및 '자주묻는질문(FAQ)'.
 *
 * -----------------------------------------------------------------------------------------------
 */

import { getSalesMainData } from 'common-modules/general/API/main';
import { ResponseSalesInfo } from 'common-modules/general/API/main/types';
import { getFAQList } from 'common-modules/general/API/support';
import { RequestFAQ, ResponseFAQ } from 'common-modules/general/API/support/types';
import MobxAsyncModel from 'common-modules/general/Model/MobxAsyncModel';
import { makeAutoObservable } from 'mobx';

export default class MainCommonModel {
  public mainData: MobxAsyncModel<ResponseSalesInfo>;
  public faqData: MobxAsyncModel<ResponseFAQ>;

  constructor() {
    this.mainData = new MobxAsyncModel(true);
    this.faqData = new MobxAsyncModel(true);

    makeAutoObservable(this);
  }

  getData = () => {
    getSalesMainData()
      .then(({ data }) => {
        this.mainData.loadSuccess(data);
      })
      .catch(() => {
        this.mainData.loadFailure();
      });
  };

  getFAQList = (params: RequestFAQ) => {
    getFAQList(params)
      .then(({ data }) => {
        this.faqData.loadSuccess(data);
      })
      .catch(() => {
        this.faqData.loadFailure();
      });
  };
}
